export enum FeedType {
  News = 'news',
  Proposal = 'proposal'
}
